export const useGenerateFileDateTimestamp = () => {
  const date = new Date();

  return `${date.getFullYear()}_${
    date.getMonth() + 1
  }_${date.getDate()}_T${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}`;
};
